import styled from 'styled-components';

import { BaseButtonProps } from './types';

export type ButtonWrapperProps = Pick<
  BaseButtonProps,
  'disabled' | 'isActive' | 'useActiveUnderline' | 'theme'
>;

const getLabelColor = (props: ButtonWrapperProps): string | undefined => {
  if (!props.theme) {
    return undefined;
  }

  if (props.disabled) {
    return props.theme.disabledColor;
  }

  if (props.isActive) {
    return props.theme.activeDefaultColor;
  }

  return props.theme.color;
};

export const ButtonLabel = styled.div<ButtonWrapperProps>`
  margin-left: 8px;

  color: ${getLabelColor};
  font-size: ${({ theme }): string | undefined => theme.fontSize};

  border-bottom: ${({ theme, isActive, useActiveUnderline }): string =>
    isActive && useActiveUnderline ? `2px solid ${theme.color}` : 'none'};
`;

export const ButtonWrapper = styled.button<ButtonWrapperProps>`
  display: inline-block;
  color: unset;
  pointer-events: auto;
  font-size: ${({ theme }): string | undefined => theme.fontSize};
  font-weight: ${({ theme }): number | undefined => theme.fontWeight};
  line-height: ${({ theme }): string | undefined => theme.lineHeight};
  text-decoration: ${({ theme }): string | undefined => theme.textDecoration};
  width: ${({ theme }): string => theme.width ?? 'auto'};
  height: ${({ theme }): string => theme.height ?? 'auto'};
  border: none;
  background-color: transparent;

  cursor: ${({ disabled }): string => (disabled ? 'unset' : 'pointer')};
  padding: 0;
  margin: 0;

  &:focus,
  &:active {
    outline: none;
  }

  &:hover:not(:disabled) ${ButtonLabel} {
    border-bottom: ${({ theme }): string =>
      theme.useActiveUnderline ? `2px solid ${theme.color}` : 'none'};
    color: ${({ theme }): string | undefined => theme.activeDefaultColor};
  }
`;
